import React, { useEffect } from 'react';
import { Route, Switch, useLocation, useHistory } from 'react-router-dom';
import AsyncComponent from './asyncComponent';
import PrivateRoute from '../Utils/PrivateRoute';
import Dashboard from '../Admin/Home';

export default function Router() {
  const location = useLocation();
  const { pathname } = location;
  const history = useHistory();

  useEffect(() => {
    if (pathname === '/') {
      history.push('/home');
    }
  }, [pathname, history]);

  return (
    <div>
      <Switch>
        <PrivateRoute path="/dashboard" component={Dashboard}/>
        
        <Route exact path="/" render={() => (
          <AsyncComponent
            importComponent={() => import('../Home')}
          />
        )} />
        <Route exact path="/home" render={() => (
          <AsyncComponent
            importComponent={() => import('../Home')}
          />
        )} />
        <Route exact path="/login" render={() => (
          <AsyncComponent
            importComponent={() => import('../Admin/Login')}
          />
        )} />
        <Route exact path="*" render={() => (
          <AsyncComponent
            importComponent={() => import('../NotFound')}
          />
        )} />
      </Switch>
    </div>
  );
}